import React , {  useEffect , useState} from 'react';
import './ProfileAbout.css';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import Footer from '../components/Footer';
import {signOut , auth , getDoc , doc , db , query , collection , where , getDocs } from '../firebase';
import { useNavigate  , Link, Navigate , useParams } from 'react-router-dom';


const ProfileAbout = () => {

  const [ ordersArray , setOrdersArray ] = useState([]);
  let { userId } = useParams();
  const [userObject , setUserObject ] = useState({});

  useEffect(  () => {

    const getNotificationsData = async () => { 

        const q = query(collection(db, "orders"), where("client_id", "==", userId ) );
   
        const querySnapshot = await getDocs(q);
      
        const ordersDataArray = querySnapshot.docs ? querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })) : '';
        
      setOrdersArray(ordersDataArray);
     
    }
    getNotificationsData();
  } , []);


  useEffect(  () => {

    const getNotificationsData = async () => { 
      const querySnapshot = await getDocs(collection(db, "orders"));
      const ordersDataArray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setOrdersArray(ordersDataArray);
     
    }
    getNotificationsData();
  } , []);






  useEffect(() => {

    window.scrollTo(0,0);
    
    const getProductsFromFirestore = async () => {
      const docRef = doc(db, "users", userId ? userId : '' );
const docSnap = await getDoc(docRef);

if (docSnap.exists()) {
 
  setUserObject(docSnap.data());
} else {

  setUserObject(null)
}


    }
    getProductsFromFirestore();

  } , []);


  let navigate = useNavigate();

  const logoutUser = () => {

    localStorage.removeItem("tourst_compass_user");

    signOut(auth).then(() => {

      navigate('/');
      
      }).catch((error) => {
       
      });

      window.location.reload();
}



  const user = JSON.parse(localStorage.getItem("tourst_compass_user"));

  return (
     <div className="main_homepage" >

{ !user ? <Navigate to="/" replace /> : ''  }
{ !userId ? <Navigate to="/" replace /> : ''  }

    <NavbarHome />

  

    <div className="section most_features_section container-sm">

    <div className="d-flex-c">

<div className="info_box"></div>
<h1 className="main_headline">   الملف الشخصي </h1>
</div>

    <div className="single_profile_section mt-5">

    <div className="d-flex-c f-sv inputs_div_coll mt-3">

<div className="input_form_div mx-3 w-100">

<label htmlFor="" className="login_label_form">الاسم الكامل</label>
<input value={userObject ? userObject.name : ''} readOnly type="text" className="login_input_form" />
</div>

<div className="input_form_div mx-3 w-100">

<label htmlFor="" className="login_label_form">  الايميل </label>
<input value={userObject ? userObject.email : ''} readOnly type="email" className="login_input_form" />
</div>


</div>

    <div className="d-flex-c f-sv inputs_div_coll mt-3">

<div className="input_form_div mx-3 w-100">

<label htmlFor="" className="login_label_form"> العمر </label>
<input value={userObject ? userObject.age : ''} readOnly type="text" className="login_input_form" />
</div>

<div className="input_form_div mx-3 w-100">

<label htmlFor="" className="login_label_form">  المدينة </label>
<input value={ userObject ? userObject.country : '' } readOnly type="text" className="login_input_form" />
</div>


</div>

    <Link to={`/edit-profile/${user.id}`} >
    <button className="btn_category hover_package w-100 mt-5"  >     تعديل الملف الشخصي  </button>
    </Link>

<button className="btn_category  bg_red w-100 mt-1" onClick={() => logoutUser() }  >    تسجيل الخروج </button>

    </div>

    </div>

    <div className="section orders_user_section container-sm">

    <div className="d-flex-c">

    <div className="info_box"></div>
    <h1 className="main_headline">    ملخص طلباتك </h1>
    </div>

    <div className="grid_places section">
    {ordersArray && ordersArray.map(({id , totalPrice}) =>  (
      <Link to={`/order/${id}`} >

    
      <div className='single_experince_div p-3 text-center' >
          <h6 className="login_label_form text-center mt-1"> الطلب : ${id} </h6>
          <button className="text-center btn_category mt-1"> مجموع الطلب : {totalPrice} ريال</button>

      </div>
      </Link>
    )) }
    </div>






    </div>


    <Footer />
    </div>
  )
}

export default ProfileAbout